(function ($) {
    var m = angular.module('order', ['utils', 'ngSanitize']);

    m.controller('OrderFormCtrl', ['$scope', '$http', '$window', function ($scope, $http, $window) {
        $scope.form = ORDER_FORM;
        $scope.coursesById = {};
        /* Loading flag */
        $scope.isLoading = false;
        $scope.captchaPagesObj = { error:1, data:[] };
        $scope.dontSendForm = false;

        // Костылик внешний - Скрываем баннер в футере на страницах заказов
        var lineBanner = document.getElementById('accept-lineBanner');
        if (lineBanner) lineBanner.style.display = 'none';

        // Получаем переформатированный объект курсов (ключ - id курса, значение - исходный объект с данными о курсе)
        $scope.coursesById = getCoursesById($scope.form.courses);
        var sendOrder = 'Записаться';
        var payOrder = 'Купить';

        // Здесь определяем массив идентификаторов цифровых курсов (без физической доставки)
        var digitalCoursesArr = ['online', 'pdf'];

        $scope.orderButtonLabel = sendOrder;

        // @todo dup code
        function getProfileProperty(field) {
            var profile = $scope.form.profile;
            if (field === 'birthday') {
                if (profile && profile.birth_date) {
                    var date = new Date(profile.birth_date);
                    return {
                        day: date.getDate() + '',
                        month: (date.getMonth() + 1) + '',
                        year: date.getFullYear() + ''
                    }
                } else {
                    return {
                        day: '',
                        month: '',
                        year: ''
                    }
                }

            }

            return profile && profile[field] ? profile[field] : null;
        }

        // ADVERTISE только на странице /test-lesson-partners
        $scope.isAdvertise = [84399].indexOf(App.queryString.recl) !== -1
            && typeof App.queryString.click_hash !== 'undefined'
            && typeof App.queryString.refid !== 'undefined'
            && location.pathname === '/order-form-partners';

        /**
         * Функция получения массива страниц с проверкой капчи
         * todo: дублируется в order.js & tl.js, но разные $scope
         */
        $scope.getCaptchaPages = function () {
            $http.get('/orders/get-captcha-pages')
                .success(function (data) {
                    if (data.captchaPages instanceof Array) {
                        $scope.captchaPagesObj.data = data.captchaPages;
                        $scope.captchaPagesObj.error = 0;
                    }
                });
        };
        $scope.getCaptchaPages(); // сразу и запрашиваем, пока пользователь заполняет форму

        /**
         * Функция подсветки при ошибках
         */
        function setError(msg) {
            $scope.isLoading = false;
            $scope.submitErrorList = [msg !== undefined ? msg : 'Перед отправкой заявки необходимо правильно заполнить поля, выделенные красным.'];
            $scope.$emit('submitErrorEvent');

            //$('div.row-center > input[type="submit"]').popover({
            $('#submit_popover').popover({
                content: $scope.submitErrorList.join('<br>'),
                placement: 'top',
                trigger: 'focus click',
                title: 'Внимание!'
            }).popover('enable').popover('show').popover('disable');
        }

        var studentNumbers = getProfileProperty('student_number');

        var region = getProfileProperty('region');

        // Если в GET-параметре задан id курса, достаем его (с проверкой наличия в массиве курсов текущей формы)
        var predefinedCourse = getPredefinedCourse(Object.keys($scope.coursesById));

        if (!predefinedCourse) {
            if ($scope.form.init && $scope.form.init.course) {
                predefinedCourse = $scope.form.init.course;
            }

            var cats = Object.keys($scope.form.courses);
            if (cats.length === 1 && $scope.form.courses[cats[0]].length === 1) {
                predefinedCourse = $scope.form.courses[cats[0]][0].id;
            }
        }

        $scope.fields = {
            course: predefinedCourse,
            phone: getProfileProperty('phone'),
            email: getProfileProperty('email'),
            name: getProfileProperty('name'),
            second_name: getProfileProperty('second_name'),
            last_name: getProfileProperty('last_name'),
            region: region === null ? '' : region,
            city: getProfileProperty('city'),
            address: getProfileProperty('address'),
            zip: getProfileProperty('zip'),
            isStudent: Boolean(studentNumbers),
            studentNumber: studentNumbers,
            hwType: $scope.form.hwType.value,
            tempo: $scope.form.tempo.value,
            receiptType: $scope.form.receiptType.value,
            shipmentType: $scope.form.shipmentType.value,
            birthday: getProfileProperty('birthday'),
            agree: true,
            payOnline: $scope.form.payOnline,
            referralStudentNumber: '',
            referralName: '',
            actionCode: '',
            courseType: 'offline'
        };

        /**
         * Универсальная форма (unitedTypes): переключение списка курсов в зависимости от типа (offline/pdf/online)
         *
         * Из-за одновременного использования в теге select AngularJS + jQuery + jQuery Form Styler приходится костылить...
         * Динамическое обновление опций селекта можно реализовать просто на нативном AngularJS (без jQuery и Form Styler),
         * но тогда потребуется изменять верстку формы. При этом нужно будет убрать из селекта директиву data-courses
         * и добавить в него ng-options="course.id as course.label group by course.group for course in coursesInSelect"
         * и формировать (можно возвращать из функции) массив JSON-объектов coursesInSelect, в каждом объекте будут:
         * {"id":1, "group":"Название категории курсов", "label":"Название курса"}
         *
         * Здесь же работа зависит от настройки формы courseType.hidden = false (по умолчанию = true),
         * которая показывает в веб-интерфейсе группу перереключателей типов курсов curseType,
         * при использовании которых вызывается метод changeCourseType(['тип1', 'тип2', ...]), изменяющий набор курсов
         * и при выборе курса срабатывает jQuery событие change. По умолчанию задан courseType = 'offline'.
         */

        $scope.form.allCourses = $scope.form.courses;
        $scope.changeCourseType = function (types) {
            $scope.form.courses = getCoursesByTypes($scope.form.allCourses, types);
            $scope.fields.course = '';
        };

        // только для универсальной формы и ширины > 991px
        if (!$scope.form.courseType.hidden && $(window).width() > 991) {
            $('#selectCourses').change(function() {
                $scope.fields.course = $('#selectCourses').val();
                $('#selectCourses').trigger('refresh'); // update jquery form styler
                // при необходимости вернуть дефолтные/обнулить значения полей форм (получение, доставка, темп, домашки)
                // ...
                $scope.$apply(); // bind with AngularJS
            });
        }
        // конец функционала для универсальной формы

        if ($scope.form.twoCourses) {
            $scope.fields.secondCourse = '';
        }

        $scope.noPk = function () {
            return $scope.currentCourse ? $scope.currentCourse.no_pk === 1 : false;
        };
        $scope.disableCourseTempFast2 = function () {
            return ['192', '193'].indexOf($scope.fields.course) != -1;
        };
        $scope.disableCourseTempFast3 = function () {
            return [].indexOf($scope.fields.course) != -1;
        };

        $scope.isFastLearning = function () {
            return ($scope.fields.tempo == $scope.form.tempo.constants.fast2x || $scope.fields.tempo == $scope.form.tempo.constants.fast3x)
        };

        $scope.onlyPk = function () {
            return $scope.currentCourse ? $scope.currentCourse.only_pk == 1 : false;
        };

        $scope.isMonthly = function () {
            return $scope.fields.receiptType == $scope.form.receiptType.constants.monthly;
        };

        $scope.isPk = function () {
            return $scope.fields.receiptType == $scope.form.receiptType.constants.pk;
        };

        $scope.isRemainders = function () {
            return $scope.fields.receiptType == $scope.form.receiptType.constants.remainders;
        };

        /**
         * Является ли выбранный курс цифровым (без физической доставки)
         * @returns {boolean}
         */
        $scope.isDigitalCourse = function () {
            if ($scope.currentCourse && digitalCoursesArr.indexOf($scope.currentCourse.course_type) !== -1) {
                return true;
            }
            return false;
        }

        $scope.isOnlineBonusPk = function () {
            return $scope.form.action.bonus.pk_online
                && ($scope.fields.shipmentType == $scope.form.shipmentType.constants.valuableParcel
                    || $scope.fields.shipmentType == $scope.form.shipmentType.constants.courier
                    || $scope.fields.shipmentType == $scope.form.shipmentType.constants.boxberry)
                && typeof $scope.form.action.bonus.pk_online !== 'undefined';
        };

        $scope.isOnlineBonusMonthly = function () { // для цифровых курсов костыль (ибо они считаются по доставке valuableParcel), когда будет отдельный вид доставки-оплаты, заменить $scope.isDigitalCourse()
            return $scope.form.action.bonus.monthly_online
                && ($scope.fields.shipmentType == $scope.form.shipmentType.constants.valuableParcel
                    || $scope.fields.shipmentType == $scope.form.shipmentType.constants.registeredMail
                    || $scope.fields.shipmentType == $scope.form.shipmentType.constants.courier
                    || $scope.fields.shipmentType == $scope.form.shipmentType.constants.boxberry
                    || $scope.isDigitalCourse())
                && typeof $scope.form.action.bonus.monthly_online !== 'undefined';
        };

        $scope.isBoxberry = function () {
            return $scope.fields.shipmentType == $scope.form.shipmentType.constants.boxberry && !$scope.isMonthly();
        }

        /**
         * Проверяем акции с бесплатной доставкой,
         * если касается всех типов доставки (неподходящие нужно вручную деактивировать) и всех способов получения (помесячка, ПК),
         * - идентификация по бонусу: freedelivery
         * если все типы доставки, но только Полный Курс сразу -  идентификация по бонусу: freedelivery_pk
         *  +
         * Цифровые курсы
         *
         * @returns {boolean}
         */
        $scope.isFreeDelivery = function () {
            if ($scope.form.action.bonus.hasOwnProperty('freedelivery')
                || ($scope.form.action.bonus.hasOwnProperty('freedelivery_pk') && $scope.isPk())
                || $scope.isDigitalCourse()) {
                return true;
            } else {
                return false;
            }
        }

        /**
         * Доступен только нормальный темп при помесячной оплате и скидке >=50%
         * (для определенных посадок)
         * @returns {boolean}
         */
        $scope.isMonthlyNormal50 = function () {
            return $scope.isMonthly() && $scope.form.action.strings.monthly_normal
                   && parseInt($scope.form.action.strings.monthly_normal) >= 50
                   && (location.pathname === '/re-emailing-offer' || location.pathname === '/re-emailing-offer-2');
        }

        /**
         * Формируем сообщение о стоимости доставки для шаблонов
         * @returns {string}
         */
        $scope.showDeliveryCost = function () {
            if ($scope.isFreeDelivery()) {
                if ($scope.isDigitalCourse()) {
                    return '';
                }
                return '+ бесплатная доставка';
            } else if ($scope.form.deliveryCost === '0') {
                return '+ стоимость доставки сообщит консультант';
            } else if ($scope.form.deliveryCost) {
                return '+ стоимость доставки ' + $scope.form.deliveryCost + ' рублей';
            } else return '';
        }

        $scope.submitErrorList = [];
        $scope.submitErrors = function () {
            return $scope.submitErrorList.join('<br>');
        };
        /**
         * Отправка формы
         */
        $scope.submit = function () {

            if ($scope.dontSendForm) return;

            /**
             * Перейти на страницу подтверждения
             */
            function redirect(data) {
                if (typeof data.redirect === 'undefined' || !data.redirect) {
                    $window.location.href = $scope.form.redirectUrl;
                } else {
                    $window.location.href = data.redirect;
                }
            }

            //для сокращенной формы пробуем поле ФИО разбить
            if (!$scope.fields.last_name && typeof $scope.fields.full_name !== 'undefined') {
                var fullName = $scope.fields.full_name.split(' ');
                if (fullName.length >= 2) {
                    $scope.fields.name = fullName[1];
                    $scope.fields.last_name = fullName[0];

                    if (fullName.length === 3) {
                        $scope.fields.second_name = fullName[2];
                    }

                } else {
                    $scope.fields.name = $scope.fields.full_name;
                }
            }

            // Проверяем есть ли кука партнерская и совпадает ли рекл
            var partner;
            var postBack = [];
            // при заказе остатков курса не считаем переход партнерским и данные не передаем
            if (!$scope.isRemainders()) {
                if (typeof App.cookie.get('partners_lead_visit') !== 'undefined'
                    && App.cookie.get('channel_code') == JSON.parse(App.cookie.get('partners_lead_visit')).recl
                ) {
                    partner = App.newpartners.getIdentifyPostBack('order');
                }

                if (partner) {
                    postBack = partner.extParams;
                }
            }

            if (!$scope.orderForm.$valid) {
                setError();
                return;
            }

            $scope.isLoading = true;

            if ($scope.fields.referralStudentNumber) {
                // disable student number if we have referrall
                $scope.fields.studentNumber = null;
            }
            var birthDate = null;

            if ($scope.fields.birthday.year && $scope.fields.birthday.month && $scope.fields.birthday.day) {
                birthDate = $scope.fields.birthday.year + '-' + $scope.fields.birthday.month + '-' + $scope.fields.birthday.day;
            }

            var postData = {
                Profiles: {
                    name: $scope.fields.name,
                    second_name: $scope.fields.second_name,
                    last_name: $scope.fields.last_name,
                    email: $scope.fields.email,
                    zip: $scope.fields.zip,
                    phone: $scope.fields.phone,
                    region: $scope.fields.region,
                    city: $scope.fields.city,
                    birth_date: birthDate,
                    address: $scope.fields.address,
                    student_numbers: $scope.fields.studentNumber,
                    referral: $scope.fields.referralStudentNumber + ($scope.fields.referralName ? ', ' + $scope.fields.referralName : '')
                },
                Order: {
                    courses_id: $scope.fields.course,
                    homework_type: $scope.form.hwType.value === null
                        ? $scope.fields.hwType
                        : $scope.form.hwType.value,

                    tempo: $scope.form.tempo.value === null
                        ? $scope.fields.tempo
                        : $scope.form.tempo.value,

                    shipment_type: $scope.form.shipmentType.value === null
                        ? $scope.form.shipmentType.value
                        : $scope.fields.shipmentType,

                    receipt_type: $scope.form.receiptType.value === null
                        ? $scope.fields.receiptType
                        : $scope.form.receiptType.value,

                    advert: $scope.form.action.advert,
                    channel_advert: ($scope.form.channelCode && !$scope.isRemainders()) ? $scope.form.channelCode : '', // must be string
                    url_parameters: (postBack.uniq && postBack.chan && !$scope.isRemainders()) ? JSON.stringify($.extend({}, JSON.parse(document.getElementById('urlParameters').value), {'PartnerParams': App.cookie.get('partners_lead_visit')})) : document.getElementById('urlParameters').value,
                    pay_online: $scope.fields.payOnline ? 1 : 0,
                    action_code: $scope.fields.actionCode,
                    //тип формы
                    type: $scope.form.type === null
                        ? 'default'
                        : $scope.form.type
                },
                ExtParams: postBack ? postBack : []
            };

            // Обработка капчи
            if ($scope.captchaPagesObj.error) {
                setError('При обработке формы произошла ошибка. Попробуйте обновить страницу или обратитесь в службу поддержки ЕШКО.');
                return;
            }

            var captcha = null;

            if ($scope.captchaPagesObj.data.indexOf(location.pathname.split('/').pop()) !== -1) {
                captcha = window.grecaptcha.getResponse();
                if (captcha === '') {
                    setError('Пожалуйста, выберите "Я не робот"');
                    grecaptcha.reset();
                    return;
                }
                postData.captcha = captcha;
            }


            if ($scope.form.twoCourses === true) {
                postData.Order.bonus = {
                    secondCourse: $scope.fields.secondCourse
                };
            }

            if ($scope.isBoxberry() && $scope.Boxberry.selectedInfo === null) {
                $scope.isLoading = false;
                $scope.submitErrorList = ['Не выбран пункт выдачи Boxberry<br/> В случае повторения ошибки обратитесь в службу поддержки'];
                $scope.$emit('submitErrorEvent');
                $scope.Boxberry.getModal();
                return;
            }

            if ($scope.Boxberry.selectedInfo) {
                if(postData.Order.hasOwnProperty('bonus')){
                    postData.Order.bonus.boxberry = {
                        'selected': $scope.Boxberry.selectedInfo,
                        'cost': $scope.form.deliveryCost
                    };
                } else {
                    postData.Order.bonus = {
                        boxberry: {
                            'selected': $scope.Boxberry.selectedInfo,
                            'cost': $scope.form.deliveryCost
                        }
                    };
                }
            }


            if ($scope.isFreeDelivery()) {
                var bonusArr = ['freedelivery', 'freedelivery_pk'];
                for (var idx = 0; idx < bonusArr.length; ++idx) {
                    var thisEl = bonusArr[idx];
                    if ($scope.form.action.bonus.hasOwnProperty(thisEl)) {
                        if (postData.Order.hasOwnProperty('bonus')) {
                            postData.Order.bonus[thisEl] = $scope.form.action.bonus[thisEl];
                        } else {
                            postData.Order.bonus = {};
                            postData.Order.bonus[thisEl] = $scope.form.action.bonus[thisEl];
                        }
                    }
                }
            }

            $http.post($scope.form.url, postData).then(
                function (data) {
                    data = data.data;
                    if (!(data.errors instanceof Array) || data.errors.length !== 0) {
                        if (captcha) {
                            grecaptcha.reset();
                        }
                        setError('Ошибка обработки заказа. Попробуйте обновить страницу или обратитесь в службу поддержки ЕШКО.');
                        return;
                    }
                    if (partner && partner.hasOwnProperty('orderConfirm') && typeof partner.orderConfirm === "function") {
                        var params = Object.assign(partner.extParams, data, {
                            pk: $scope.isPk(),
                            courseInfo: $scope.currentCourse,
                            selectedPrice: parseInt($scope.selectedPrice)
                        }, postData.Order, postData.Profiles);
                        var promise = partner.orderConfirm(params);
                        promise.then(function () {
                            // Эти блоки try-catch исключительно для отправки данных о заказах партнеру ГдеСлон
                            try {
                                var gdeSlonPromise = App.newpartners.processGdeSlon(postData.Profiles.email);
                                gdeSlonPromise.then(function () {
                                    redirect(data);
                                });
                            } catch (e) {
                                console.log('Something wrong with processGdeSlon()');
                                redirect(data);
                            }
                        });
                    } else {
                        try {
                            var gdeSlonPromise = App.newpartners.processGdeSlon(postData.Profiles.email);
                            gdeSlonPromise.then(function () {
                                redirect(data);
                            });
                        } catch (e) {
                            console.log('Something wrong with processGdeSlon()');
                            redirect(data);
                        }
                    }
                },
                function () {
                    if (captcha) {
                        grecaptcha.reset();
                    }
                    setError();
                });
        };

        /**
         * Получаем тип покупки SBS помесячки ускоренный 1-2 и PK
         * @returns {*}
         */
        function getBuyType() {
            if ($scope.isPk()) {
                return 3;
            } else {
                return $scope.fields.tempo;
            }
        }

        $scope.checkZipLength = function () {
            return $scope.fields.zip && $scope.fields.zip.length === 6;
        }

        /**
         * Рассчет фиксированной стоимости доставки
         */
        $scope.calculateDeliveryPrice = function () {
            if ($scope.isDigitalCourse()) {
                $scope.fields.payOnline = true;
                $scope.orderButtonLabel = payOrder;
                return;
            }
            var type = getBuyType();
            if (!type) {
                $scope.form.deliveryCost = '';
                $scope.orderButtonLabel = sendOrder;
                $scope.fields.payOnline = false;
                return;
            }

            var parcelPk = ($scope.form.shipmentType.constants.valuableParcel == $scope.fields.shipmentType && $scope.isPk());
            var parcelMonthly = ($scope.form.shipmentType.constants.registeredMail == $scope.fields.shipmentType && $scope.isMonthly());

            if (!($scope.isMonthly() || $scope.isPk()) || !$scope.fields.region || !$scope.fields.zip || typeof $scope.currentCourse === 'undefined') {
                $scope.form.deliveryCost = '';
                $scope.orderButtonLabel = sendOrder;
                $scope.fields.payOnline = false;
                return;
            }

            $scope.orderButtonLabel = payOrder;

            if (!$scope.isBoxberry()) {
                if ($scope.isFreeDelivery()) {
                    if (parcelPk || parcelMonthly) {
                        $scope.fields.payOnline = true;
                        $scope.orderButtonLabel = payOrder;
                    } else {
                        $scope.fields.payOnline = false;
                        $scope.orderButtonLabel = sendOrder;
                    }
                } else {
                    $http.post('/api/get-delivery-cost', {
                        'zip': $scope.fields.zip,
                        'courseId': $scope.currentCourse.id,
                        'type': parseInt(type),
                        'isPk': parseInt($scope.fields.receiptType),
                        'shipmentType': parseInt($scope.fields.shipmentType),
                        'receiptType': parseInt($scope.fields.receiptType),
                        'price': parseInt($scope.selectedPrice),
                        'secondCourseId': parseInt($scope.fields.secondCourse)
                    })
                        .success(function (answer) {
                            if (answer.success === false) {
                                $scope.form.deliveryCost = '0'; // было '' - пока уравняли 0=''
                                $scope.orderButtonLabel = sendOrder;
                                setError('Невозможно посчитать стоимость доставки. Пожалуйста, обратитесь в службу поддержки.');
                                $scope.dontSendForm = true;
                                return;
                            }

                            if (answer.data.cost) {

                                $scope.form.deliveryCost = answer.data.cost;

                                if (parcelPk || parcelMonthly) {
                                    $scope.fields.payOnline = true;
                                    $scope.orderButtonLabel = payOrder;
                                } else {
                                    $scope.fields.payOnline = false;
                                    $scope.orderButtonLabel = sendOrder;
                                }

                            } else {
                                $scope.form.deliveryCost = '0'; // было '' - пока уравняли 0=''
                                $scope.fields.payOnline = false;
                                $scope.orderButtonLabel = sendOrder;
                            }
                        })
                        .error(function () {
                            $scope.form.deliveryCost = '0'; // было '' - пока уравняли 0=''
                            $scope.orderButtonLabel = sendOrder;
                            setError('Невозможно посчитать стоимость доставки. Пожалуйста, обратитесь в службу поддержки.');
                            $scope.dontSendForm = true;
                        });
                }
            }
        }

        /**
         * @todo move to some other file. dup code
         */
        var groupsDirty = {};

        var watchDirtyFields = [
            'shipmentType',
            'agree'
        ];


        /**
         * @todo move to some other file. dup code
         */
        $scope.$watchGroup(watchDirtyFields.map(function (item) {
            return 'fields.' + item;
        }), function (groups) {
            for (var i in groups) {
                if (groups[i]) {
                    groupsDirty[watchDirtyFields[i]] = true;
                }
            }
        });

        /**
         * Поля нужные для пересчета стоимости доставки
         * @type {[*]}
         */
        var watchFieldsReCalShipment = [
            'fields.shipmentType',
            'fields.tempo',
            'fields.region',
            'fields.receiptType',
            'fields.zip',
            'currentCourse',
            'fields.secondCourse',
            'Boxberry.selectedInfo'
        ];

        /**
         * Наблюдатель за полями для рекалькуляции доставки
         */
        $scope.$watchGroup(watchFieldsReCalShipment, function () {
            $scope.calculateDeliveryPrice();
            $scope.checkZipLength();
            $scope.Boxberry.selectedInfo;
        });

        /**
         * Proxy angular validation class names
         * @todo move to some other file. dup code
         * @param  {string} fieldName field name in orderForm
         * @return {object}           angular class definition object
         */
        $scope.groupValidationClass = function (fieldName) {
            var control = $scope.orderForm[fieldName];

            return {
                'ng-invalid': control.$invalid,
                'ng-dirty': groupsDirty[fieldName]
            };
        };


        $scope.activeDiscountMonthly = function () {
            var out = false;
            if ($scope.form.action.strings.monthly_normal) {
                out = $scope.form.action.strings.monthly_normal;
            }

            if ($scope.isOnlineBonusMonthly()) {
                out = (parseInt($scope.form.action.strings.monthly_normal) + parseInt($scope.form.action.bonus.monthly_online)) + '%';
            }

            if (
                $scope.form.action.strings.monthly_speed &&
                ($scope.fields.tempo == $scope.form.tempo.constants.fast2x
                    || $scope.fields.tempo == $scope.form.tempo.constants.fast3x)
            ) {
                out = $scope.form.action.strings.monthly_speed;
            }

            if ($scope.isFastLearning() && $scope.isOnlineBonusMonthly() && $scope.form.action.strings.monthly_speed) {
                out = (parseInt($scope.form.action.strings.monthly_speed) + parseInt($scope.form.action.bonus.monthly_online)) + '%';
            }

            return out;
        };

        $scope.activeDiscountPk = function () {
            var out = false;
            if ($scope.form.action.strings.pk) {
                out = $scope.form.action.strings.pk;
            }

            if ($scope.isOnlineBonusPk()) {
                out = (parseInt($scope.form.action.strings.pk_num) + parseInt($scope.form.action.bonus.pk_online)) + '%';
            }

            return out;
        };

        $scope.activeBonusMonthly = function () {
            var out = false;

            if ($scope.form.action.bonus !== null && $scope.form.action.bonus.monthly_normal) {
                out = ' ' + $scope.form.action.bonus.monthly_normal;
            }

            if (
                $scope.form.action.bonus !== null &&
                $scope.form.action.bonus.monthly_speed &&
                ($scope.fields.tempo == $scope.form.tempo.constants.fast2x
                    || $scope.fields.tempo == $scope.form.tempo.constants.fast3x)
            ) {
                out = ' + ' + $scope.form.action.bonus.monthly_speed;
            }

            return out;
        };

        $scope.activeBonusPk = function () {
            var out = false;
            if ($scope.form.action.bonus !== null && $scope.form.action.bonus.pk) {
                out = ' ' + $scope.form.action.bonus.pk;
            }
            return out;
        };

        /**
         * Бонус, если акция зависит от доставки курьером
         *
         * @returns {string}
         */
        $scope.deliveryCourierBonus = function () {
            var result = '';
            if (
                $scope.fields.shipmentType == $scope.form.shipmentType.constants.courier
                && typeof $scope.form.action.bonus !== 'undefined'
                && $scope.form.action.bonus
                && typeof $scope.form.action.bonus.deliveryCourier !== 'undefined'
            ) {
                result = '+ ' + $scope.form.action.bonus.deliveryCourier;
                if (!$scope.activeDiscountPk() && !$scope.activeBonusPk()) {
                    result = +' + скидка ';
                }
            }
            return result;
        };

        /**
         * Применение динамической акции
         */
        $scope.applyCustomAction = function () {
            var request = {
                token: $scope.form.dynamicActionToken,
                advert: $scope.fields.customAction
            };

            $http.post('/orders/config-form', request)
                .success(function (data) {
                    if (data.error) {
                        $scope.dynamicActionMessage = data.message;
                        $scope.$broadcast('dynamicActionSubmit');
                    } else {
                        if (data.action) {
                            $scope.form.action = data.action;
                        }
                        if (data.courses) {
                            $scope.form.courses = data.courses;
                            $scope.$emit('defnone-set'); // сбросить начальные плейсхолдеры если надо
                        }

                        $('body').trigger('action:changed', {
                            data: data
                        });

                        $scope.actionChanged = true;
                    }
                })
                .error(function (data) {
                    $scope.dynamicActionMessage = 'Невозможно применить акцию';
                    $scope.$broadcast('dynamicActionSubmit');
                });
        };

        $scope.isPayOnline = function () {
            return $scope.fields.payOnline;
        };

        // Update total price for selected course in case of pay online
        $scope.selectedPrice = 0;

        $scope.$watchGroup(['fields.receiptType', 'fields.course'], function () {
            if ($scope.Boxberry.selectedInfo !== null) {
                if ($('#boxberry-modal').hasClass('in')) {
                    $scope.Boxberry.bbList.modal('hide');
                }
                $scope.Boxberry.selectedInfo = null;
                $scope.Boxberry.selectedFullAddr = null;
                $scope.Boxberry.bbLoading = true;
                $scope.Boxberry.bbLoadingNode.show().html('<img src="/assets/img/preloader-new.svg" alt="Загрузка" title="Загрузка">');

                if ($scope.isBoxberry()) {
                    $scope.fields.shipmentType = $scope.form.shipmentType.constants.valuableParcel;
                }
            }
        })

        //watch for all fields вызывается при изменении любого поля формы
        $scope.$watch('fields', function () {
            $scope.currentCourse = $scope.coursesById[$scope.fields.course << 0];

            if ($scope.onlyPk()) {
                $scope.fields.receiptType = $scope.form.receiptType.constants.pk;
            }
            if ($scope.isMonthlyNormal50()
                || ($scope.disableCourseTempFast2() && $scope.disableCourseTempFast3())
                || ($scope.disableCourseTempFast2() && $scope.fields.tempo == String($scope.form.tempo.constants.fast2x))) {
                $scope.fields.tempo = String($scope.form.tempo.constants.normal);
            } else if($scope.disableCourseTempFast3() && $scope.fields.tempo == String($scope.form.tempo.constants.fast3x)) {
                $scope.fields.tempo = String($scope.form.tempo.constants.fast2x);
            }
            if ($scope.noPk()) {
                if ($scope.form.receiptType.disabled.indexOf($scope.form.receiptType.constants.monthly) == -1) {
                    $scope.fields.receiptType = $scope.form.receiptType.constants.monthly;
                    $scope.fields.tempo = String($scope.form.tempo.constants.normal);
                } else {
                    $scope.fields.receiptType = null;
                }
            }

            if ($scope.isPk() && $scope.fields.shipmentType == $scope.form.shipmentType.constants.simple) {
                delete $scope.fields.shipmentType;
            }

            if ($scope.isMonthly() && $scope.fields.shipmentType == $scope.form.shipmentType.constants.courier) {
                $scope.fields.shipmentType = $scope.form.shipmentType.constants.payOnDelivery;
            }

            if ($scope.isFastLearning() && $scope.fields.shipmentType == $scope.form.shipmentType.constants.simple) {
                delete $scope.fields.shipmentType;
            }

            if ($scope.isDigitalCourse()) {
                // для цифровых курсов только онлайн предоплата, пока костылим с помощью valuableParcel, todo: завести свой вид доставки для цифровых
                $scope.fields.shipmentType = $scope.form.shipmentType.constants.valuableParcel;
                $scope.fields.hwType = $scope.form.hwType.constants.online;
                $scope.form.hwType.disabled = [0];
            } else if (
                $scope.fields.shipmentType == $scope.form.shipmentType.constants.valuableParcel ||
                $scope.fields.shipmentType == $scope.form.shipmentType.constants.registeredMail
            ) { // установка правильных значений при смене радио с ценной посылки на заказную бандероль и наоборот
                $scope.form.hwType.disabled = [];
                var shipmentType;
                if ($scope.isPk()) {
                    shipmentType = $scope.form.shipmentType.constants.valuableParcel
                } else {
                    shipmentType = $scope.form.shipmentType.constants.registeredMail;
                }
                if ($scope.form.shipmentType.disabled.indexOf(shipmentType) == -1) {
                    $scope.fields.shipmentType = shipmentType;
                } else {
                    $scope.fields.shipmentType = null;
                }
            }

            if($scope.fields.shipmentType == $scope.form.shipmentType.constants.boxberry && $scope.isMonthly()){
                $scope.fields.shipmentType = $scope.form.shipmentType.constants.registeredMail;
            }

            if (!$scope.checkZipLength()) {
                if ($('#boxberry-modal').hasClass('in')) {
                    $scope.Boxberry.bbList.modal('hide');
                }
                $scope.Boxberry.selectedInfo = null;
                $scope.Boxberry.selectedFullAddr = null;
                $scope.Boxberry.bbLoading = true;
                $scope.Boxberry.bbLoadingNode.show().html('<img src="/assets/img/preloader-new.svg" alt="Загрузка" title="Загрузка">');

                if ($scope.isBoxberry()) {
                    $scope.fields.shipmentType = $scope.form.shipmentType.constants.valuableParcel;
                }
            }

            if (!$scope.isBoxberry() && $scope.Boxberry.selectedInfo !== null) {
                $scope.Boxberry.selectedInfo = null;
                $scope.Boxberry.selectedFullAddr = null;
                $scope.Boxberry.bbLoading = true;
                $scope.Boxberry.bbLoadingNode.show().html('<img src="/assets/img/preloader-new.svg" alt="Загрузка" title="Загрузка">');
            }

            if ($scope.isBoxberry() && $scope.Boxberry.selectedInfo === null) {
                // действия перед отрисовкой модалки
                $scope.Boxberry.getModal();

                // @TODO: куда-то вынести
                $(document).on('click', '.bb-selectable', function (e) {
                    e.preventDefault();
                    var that = $scope.Boxberry;
                    var clicked = $(this);
                    var deliveryCost = null;
                    var info = null;
                    var fullAddr = null;
                    if (clicked.data('point-name')) {
                        deliveryCost = that.bbData.DeliveryPoints.cost;
                        info = clicked.data('point-name');
                        fullAddr = clicked.find('#thisPointAddress').text();
                    } else if (clicked.data('courier')) {
                        deliveryCost = that.bbData.Courier.cost;
                        info = 'Курьер ' + clicked.data('delivery-code')
                    }

                    // Переопределяем, если бесплатная доставка
                    if ($scope.isFreeDelivery()) {
                        deliveryCost = 0;
                    }

                    $scope.form.deliveryCost = deliveryCost;

                    // скрываем модалку
                    that.bbList.modal('hide');

                    // записываем значение
                    that.selectedInfo = info;
                    that.selectedFullAddr = fullAddr ? fullAddr : info;
                    $scope.fields.payOnline = true;
                    $scope.$apply();
                })

            }

            //рассчет цены курса при разных типах отправки
            var type = getBuyType();
            var priceName = 'modTotal';

            //Это все Женя он не хотел делать на серваке.. все вопросы к нему.
            if ($scope.isOnlineBonusPk() || $scope.isOnlineBonusMonthly()) {
                if (type === 3) {
                    priceName = 'modTotalOnline';
                } else {
                    priceName = 'modPriceOnline';
                }
            } else {
                if (type === 3) {
                    priceName = 'modTotal';
                } else {
                    priceName = 'modPrice';
                }
            }

            switch (type) {
                case 3:
                    $scope.selectedPrice = $scope.currentCourse ? $scope.currentCourse[priceName] : 0;
                    break;
                case "2":
                    $scope.selectedPrice = $scope.currentCourse ? ($scope.currentCourse[priceName] * 3) : 0;
                    break;
                case "1":
                    $scope.selectedPrice = $scope.currentCourse ? ($scope.currentCourse[priceName] * 2) : 0;
                    break;
                default:
                    $scope.selectedPrice = $scope.currentCourse ? $scope.currentCourse[priceName] : 0;
                    break;
            }
        }, true);

        $scope.Boxberry = {
            bbLoading: true,
            bbLoadingNode: $('#bbLoading'),
            bbList: $('#boxberry-modal'),
            bbListContent: $('#boxberry-modal-content'),
            tableBBPoints: $('table#boxberry-points'),
            tableBBCourier: $('table#boxberry-courier'),
            bbData: null,
            selectedInfo: null,
            selectedFullAddr: null,
            map: null,

            tablesHide: function () {
                this.tableBBCourier.hide()
                this.tableBBPoints.hide()
            },
            tablesShow: function () {
                this.tableBBCourier.show()
                this.tableBBPoints.show()
            },

            getData: function () {
                var that = this;
                this.bbLoadingNode.show().html('<img src="/assets/img/preloader-new.svg" alt="Загрузка" title="Загрузка">');

                if (this.map !== null) {
                    this.map.destroy();
                }
                this.tablesHide();

                var recl = App.queryString.recl ? App.queryString.recl : App.cookie.get("channel_code") ? App.cookie.get("channel_code") : window.ORDER_FORM.action.advert;

                $http.post('/post/boxberry/data', {
                    'zip': $scope.fields.zip,
                    'is_full': parseInt($scope.fields.receiptType) === 0 ? 0 : 1,
                    'courseId': $scope.currentCourse.id,
                    'recl': parseInt(recl)
                })
                    .success(function (resp) {
                        that.bbData = resp;
                        if (typeof resp.DeliveryPoints === 'undefined' || typeof resp.Courier === 'undefined') {
                            // @TODO: вынести в отдельный метод
                            return that.bbLoadingNode.html('<div style="margin-top: 70px; background-color: #ffffff">Не удалось посчитать доставку. Обратитесь в службу поддержки.</div>')
                        }
                        that.bbLoading = false;
                        if (!that.bbLoading) {
                            that.bbLoadingNode.hide();
                            that.setModalHtml(resp);
                            that.initYandexMap(resp);
                            that.tablesShow();
                        }
                    })
                    .catch(function (resp) {
                        // @TODO: вынести в отдельный метод
                        return that.bbLoadingNode.text('<div style="margin-top: 70px; background-color: #ffffff">Не удалось посчитать доставку. Обратитесь в службу поддержки.</div>')
                    })
            },

            getModal: function () {
                this.bbList.on("shown.bs.modal").modal('show');
                this.getData();
            },

            initYandexMap: function (bbData) {
                var points = bbData.DeliveryPoints.points;

                if (bbData.DeliveryPoints.cost > 0) {
                    this.map = new ymaps.Map("map", {
                        center: JSON.parse('[' + points[0].PointGPS + ']'),
                        zoom: 12
                    })
                    this.map.controls.remove('searchControl');

                    for (i = 0; i < points.length; ++i) {
                        if (points[i].PointGPS) {
                            var coordinates = '[' + points[i].PointGPS + ']';
                            var pointGPS = JSON.parse(coordinates.replace(',.', '.'));
                            var mark = new ymaps.Placemark(pointGPS, {
                                balloonContent: '<b>'
                                + points[i].PointAdress
                                + '</b><br>'
                                + points[i].PointWorkSchedule
                                + '<br>'
                                + points[i].PointPhone
                                + '<br>'
                                + '<button class="bb-selectable btn btn-success btn-xs" data-point-code="' + points[i].PointCode + '" data-point-name="' + points[i].PointName + '">' +
                                '<span id="thisPointAddress" style="display: none;">' + points[i].PointAdress + '</span>' +
                                '<strong>Выбрать</strong></button>'
                            })

                            this.map.geoObjects.add(mark);
                        }
                    }
                } else {
                    // @TODO: вынести в отдельный метод
                    $('#bbMap').html('')
                        .append('<div class="bb-error">Ошибка получения пунктов выдачи Boxberry. Попробуйте обновить страницу или обратитесь в службу поддержки ЕШКО.</div>');
                }
            },

            setModalHtml: function (bbData) {
                var that = this;
                var pointCost = bbData.DeliveryPoints.cost;
                var points = bbData.DeliveryPoints.points;
                var courier = bbData.Courier;

                if (courier.cost > 0) {
                    var shownCostCourier = $scope.isFreeDelivery() ? 0 : courier.cost;
                    that.tableBBCourier.html(
                        '<tr class="bb-selectable" data-delivery-code="' + courier.delivery_code + '" data-courier="true">' +
                        '<td>Доставка курьером: <b>' + shownCostCourier + '</b> руб.</td>' +
                        '<td>Примерное время доставки: <b>' + courier.delivery_time + '</b> раб. дн.</td>' +
                        '</tr>'
                    );
                } else {
                    that.tableBBCourier.html('');
                }

                if (pointCost > 0) {
                    var shownCostPoint = $scope.isFreeDelivery() ? 0 : pointCost;
                    that.tableBBPoints.html(
                        '<tr>' +
                        '<th>Доставка до пунктов выдачи Boxberry</th>' +
                        '<td style="background-color: #f9f9a1;">Стоимость: <b>' + shownCostPoint + '</b> руб.</td>' +
                        '</tr>'
                    );

                    points.forEach(function (item) {
                        that.tableBBPoints.append(
                            '<tr class="bb-selectable" data-point-code="' + item.PointCode + '" data-point-name="' + item.PointName + '">' +
                            '<td><b id="thisPointAddress">' + item.PointAdress + '</b><br>' + item.PointWorkSchedule + '</td>' +
                            '<td>' + item.PointPhone + '</td>' +
                            '</tr>');
                    });
                } else {
                    // @TODO: вынести в отдельный метод
                    $('#bbList').html('')
                        .append('<div class="bb-error">Ошибка получения пунктов выдачи Boxberry. Попробуйте обновить страницу или обратитесь в службу поддержки ЕШКО.</div>');
                }
            }
        }

    }]);

    m.filter('cost_wrapped', function () {
        return function (str) {
            return str.replace(/\d*\.?\d*/ig, function replace(match) {
                if (match === '') return ''; else return '<span class="link">' + match + '</span>';
            })
        };
    });
})(jQuery);
